import React from "react";
import { Box, Grid, Typography, Link } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";

// ✅ import the hook
import { useThemeLogoUrl } from "../../common/useThemeLogoUrl";

const Footer = () => {
  const themeLogoUrl = useThemeLogoUrl();

  return (
    <>
      {/* Footer */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#fff",
          padding: "40px 0",
          borderTop: "1px solid #e0e0e0",
          mt: 4,
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            padding: { xs: "0 20px", md: 0 },
          }}
        >
          {/* Logo and Copyright */}
          <Box
            sx={{
              flex: 1,
              minWidth: { xs: "100%", md: "250px" },
              marginBottom: { xs: "30px", md: 0 },
              marginRight: { xs: 0, md: "50px" },
            }}
          >
            {/* 🔁 Dynamic logo just like header */}
            {themeLogoUrl && (
              <Box
                component="img"
                src={themeLogoUrl}
                alt="Logo"
                sx={{
                  maxWidth: "120px",
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            )}


            <Typography variant="body2" sx={{ color: "#333", mt: 2 }}>
              Copyright © 2025 Del Toro Insurance
            </Typography>
            <Link
              href="/privacy-policy"
              underline="hover"
              sx={{
                color: "#333",
                fontSize: "14px",
                display: "block",
                marginTop: "5px",
              }}
            >
              Privacy Policy
            </Link>
          </Box>

          {/* Navigation Columns (unchanged) */}
          <Grid container spacing={3} sx={{ flex: 2 }}>
            {/* Company Column */}
            <Grid item xs={6} sm={3}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", marginBottom: "15px", color: "#333" }}
              >
                COMPANY
              </Typography>
              <Box component="ul" sx={{ padding: 0, margin: 0, listStyle: "none" }}>
                <Box component="li" sx={{ marginBottom: "10px" }}>
                  <Link href="/about-us" underline="hover" sx={{ color: "#333", fontSize: "14px" }}>
                    About Us
                  </Link>
                </Box>
                <Box component="li" sx={{ marginBottom: "10px" }}>
                  <Link href="/careers" underline="hover" sx={{ color: "#333", fontSize: "14px" }}>
                    Careers
                  </Link>
                </Box>
                <Box component="li" sx={{ marginBottom: "10px" }}>
                  <Link href="/acquisitions" underline="hover" sx={{ color: "#333", fontSize: "14px" }}>
                    Acquisitions
                  </Link>
                </Box>
              </Box>
            </Grid>

            {/* Get In Touch Column */}
            <Grid item xs={6} sm={3}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", marginBottom: "15px", color: "#333" }}
              >
                GET IN TOUCH
              </Typography>
              <Box component="ul" sx={{ padding: 0, margin: 0, listStyle: "none" }}>
                <Box component="li" sx={{ marginBottom: "10px" }}>
                  <Link href="/contact-us" underline="hover" sx={{ color: "#333", fontSize: "14px" }}>
                    Contact Us
                  </Link>
                </Box>
                <Box component="li" sx={{ marginBottom: "10px" }}>
                  <Link
                    href="/terms-and-conditions"
                    underline="hover"
                    sx={{ color: "#333", fontSize: "14px" }}
                  >
                    Terms and Conditions
                  </Link>
                </Box>
              </Box>
            </Grid>

            {/* Policyholders Column */}
            <Grid item xs={6} sm={3}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", marginBottom: "15px", color: "#333" }}
              >
                POLICYHOLDERS
              </Typography>
              <Box component="ul" sx={{ padding: 0, margin: 0, listStyle: "none" }}>
                <Box component="li" sx={{ marginBottom: "10px" }}>
                  <Link
                    href="/payments-and-claims"
                    underline="hover"
                    sx={{ color: "#333", fontSize: "14px" }}
                  >
                    Payments and Claims
                  </Link>
                </Box>
              </Box>
            </Grid>

            {/* Social Media Column */}
            <Grid item xs={6} sm={3}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", marginBottom: "15px", color: "#333" }}
              >
                SOCIAL
              </Typography>
              <Box sx={{ display: "flex", gap: "10px" }}>
                {[
                  { icon: FacebookIcon, label: "Facebook" },
                  { icon: InstagramIcon, label: "Instagram" },
                  { icon: TwitterIcon, label: "Twitter" },
                  { icon: YouTubeIcon, label: "YouTube" },
                  { icon: LinkedInIcon, label: "LinkedIn" },
                ].map(({ icon: Icon, label }, index) => (
                  <Link key={index} href="#" aria-label={label}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#333",
                        color: "white",
                        borderRadius: "50%",
                        "&:hover": { backgroundColor: "#ff0000" },
                      }}
                    >
                      <Icon fontSize="small" />
                    </Box>
                  </Link>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
